import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';
import 'zone.js';

export const topgolfCustomerGroup = 'topgolf';
export const customerGroup = topgolfCustomerGroup;
const supportEmail = {
	topgolf: 'topgolf@smoothr.de',
};

export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDx99_I34aUK3cLhF7zTI6Uxcq6FP9qKvA',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	countryList: ['ch'],
	gaId: '',
	hasRecommendations: true,
	location: '',
	deactivateDelivery: false,
	enableCashPayment: true,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	applePayMerchant: 'merchant.com.adyen.de.smoothr.topgolf.test',
	googlePayMerchant: 'BCR2DN6T5OYNT6CG',
	googlePayMerchantName: 'TopGolf',
	googlePayEnvironment: 'TEST',
	applePayEnvironment: 'TEST',
	adyenEnvironment: 'test',
	// Auto-detect: Use deployed URL if not on localhost, otherwise use localhost
	paymentAppUrl: window.location.hostname === 'localhost' ? 'http://localhost:4201' : 'https://dev-topgolf.smoothr.de',
	doubleMondayId: 221, // D_MONDAY
	doubleMondayCode: 'D_MONDAY',
	deinstagId: 48, // DEINSTAG
	deinstagCode: 'DEINSTAG',
	deinstagPlus: ['80300003', '80200047'],
	studentsId: 26, // S_THURSDAY
	studentsCode: 'S_THURSDAY',
	topgolfPaymentUrl: 'https://dev-topgolf.smoothr.de',
};
